import Vue from "vue"
import VueRouter from "vue-router"

import Home from "../views/Home.vue"
import Profile from "../views/Profile.vue"
import GithubApi from "../views/GithubApi.vue"
import Contact from "../views/Contact.vue"

import Photos from "../views/MyPhotos.vue"
import Login from "../views/Login.vue"
import Posts from "../views/Posts.vue"
import Cv from "../views/Cv.vue"
import Admin from "../views/Admin.vue"

// import MyTools from "./../components/My-Too";	
import Skills from "../views/Skills.vue"
import Projects from "../views/Projects.vue"
import Blog from "../views/Blog.vue"

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Home",
		component: Profile
	},
	{
		path: "/home",
		name: "Home",
		component: Home
	},
	{
		path: "/contact",
		component: Contact
	},
	{
		path: "/profile",
		component: Profile
	},
	{
		path: "/githubapi",
		component: GithubApi
	},

	{
		path: "/photos",
		component: Photos
	},
	{
		path: "/posts",
		component: Posts
	},
	{
		path: "/cv",
		component: Cv
	},
	{
		path: "/adm",
		component: Admin
	},
	{
		path: "/login",
		component: Login
	},
	{
		path: "/skills",
		component: Skills
	},
	{
		path: "/projects",
		component: Projects
	},
	{
		path: "/blog",
		component: Blog
	}
];
const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes
});
export default router;
